import { PreviewAspectRatio } from "../models";

const MIN_ASPECT_RATIO_9_16 = 0.4;
const MAX_ASPECT_RATIO_9_16 = 0.6;
const MIN_ASPECT_RATIO_3_4 = 0.7;
const MAX_ASPECT_RATIO_3_4 = 0.8;

export const isValidAspectRatio = (
    width: number,
    height: number,
    rotation?: number,
    aspectRatioType?: PreviewAspectRatio,
): boolean => {
    const aspectRatio =
        rotation && Math.abs(rotation) === 90
            ? height / width
            : // for all other rotation values - 0, 180, arbitrary values
              // fallback to default aspect ratio check
              width / height;

    if (aspectRatioType === PreviewAspectRatio.threeFour) {
        return aspectRatio >= MIN_ASPECT_RATIO_3_4 && aspectRatio <= MAX_ASPECT_RATIO_3_4;
    }

    return aspectRatio >= MIN_ASPECT_RATIO_9_16 && aspectRatio <= MAX_ASPECT_RATIO_9_16;
};
